import React from 'react'
import { object, func } from 'prop-types'

import Input from 'coact/Input'

function ScopeSetting (props) {
  const { style, spliter, changeScope } = props
  return (
    <div>
      <span>S:</span>
      <Input type="number" {...spliter(props)('s1')} />
      <span>~</span>
      <Input type="number" {...spliter(props)('s2')} />
      <span>C:</span>
      <Input type="number" {...spliter(props)('c1')} />
      <span>~</span>
      <Input type="number" {...spliter(props)('c2')} />
      <div className={style.setting} onClick={changeScope}>設定範圍</div>
    </div>
  )
}
ScopeSetting.propTypes = {
  spliter: func.isRequired,
  changeScope: func.isRequired,
  style: object.isRequired,
}

export default ScopeSetting



// WEBPACK FOOTER //
// ./src/components/RangeEditor/ScopeSetting/ScopeSetting.jsx